<template>
    <div class="form-group currency-picker">
        <label class="form-label section-title">{{ $t('messages.currency_title') }}</label>
        <div class="currency-control">
            <select class="form-select" v-model="localCurrency" @change="updateCurrency" :disabled="locked">
                <option v-for="currency in currencies" :key="currency.currency" :value="currency.currency">
                    {{ $t(`messages.currencies.${currency.currency}`) }} ({{
                        $t(`messages.currency_symbols.${currency.currency}`) }})
                </option>
                <!-- Ensure current currency is visible even if not present in currencies list -->
                <option v-if="!hasLocalInList" :value="localCurrency">{{ $t(`messages.currencies.${localCurrency}`) ||
                    localCurrency }} ({{ $t(`messages.currency_symbols.${localCurrency}`) || localCurrency }})</option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
    name: "Currency",
    props: {
        currency: {
            type: String,
            default: 'USD'
        },
        locked: {
            type: Boolean,
            default: false
        },
        currencies: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            localCurrency: this.currency
        };
    },
    computed: {
        hasLocalInList() {
            return (this.currencies || []).some(c => c.currency === this.localCurrency);
        }
    },
    watch: {
        currency(newValue) {
            this.localCurrency = newValue;
        },
        locked(newVal) {
            if (newVal) {
                // force KZT when locked
                this.localCurrency = 'KZT';
                this.updateCurrency();
            }
        }
    },
    methods: {
        updateCurrency() {
            this.$emit('update', this.localCurrency);
        }
    }
};
</script>
